import React from "react";
import classNames from "classnames";
import { Meet } from "types";
import round from "lodash/round";

const PointsCell = ({
  data,
  column,
  meet,
  style,
}: {
  data: any;
  column: any;
  meet: Meet;
  style: React.CSSProperties;
}) => {
  const team = data;

  if (team.row === "header") {
    return (
      <div style={style} className="table-cell-inner">
        {column.label}
      </div>
    );
  } else if (team.row === "title") {
    return <div style={style} className="table-cell-inner" />;
  } else {
    return (
      <div style={style} className={classNames("table-cell-inner")}>
        {!!team.teamPointsContributed && round(team.teamPointsContributed, 3)}
      </div>
    );
  }
};

export default PointsCell;
